import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './PaymentModal.css';

function PaymentModal({ isOpen, onClose, onConfirm, order, total }) {
  const { t } = useTranslation();
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [amount, setAmount] = useState(total);
  const [error, setError] = useState('');

  useEffect(() => {
    setAmount(total);
  }, [total]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (paymentMethod === 'account' && !order.customerId && !order.customerData?.customerId) {
      setError(t('orders.payment.accountRequiresCustomer'));
      return;
    }

    onConfirm({
      method: paymentMethod,
      amount: parseFloat(amount),
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{t('orders.payment.title')}</h2>
        </div>

        <div className="modal-body">
          <div className="order-summary">
            <p>
              {t('orders.total')}: <strong>${total.toFixed(2)}</strong>
            </p>
            {order.customerName && (
              <p>
                {t('orders.customerLabel')}: {order.customerName}
              </p>
            )}
          </div>

          <div className="form-group">
            <label>{t('orders.payment.method')}</label>
            <select
              value={paymentMethod}
              onChange={(e) => {
                setPaymentMethod(e.target.value);
                setError('');
              }}
            >
              <option value="cash">{t('payment.cash')}</option>
              <option value="card">{t('payment.card')}</option>
              <option value="transfer">{t('payment.transfer')}</option>
              <option value="account">{t('payment.account')}</option>
            </select>
          </div>

          {paymentMethod === 'account' && (
            <div className="info-alert">{t('orders.payment.accountInfo')}</div>
          )}

          {error && <p className="error-text">{error}</p>}
        </div>

        <div className="modal-actions">
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            {t('common.cancel')}
          </button>
          <button type="button" className="btn btn-primary" onClick={handleConfirm}>
            {t('orders.payment.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentModal;
